import { render, staticRenderFns } from "./OccupationPage.vue?vue&type=template&id=5a80d649&"
import script from "./OccupationPage.vue?vue&type=script&lang=js&"
export * from "./OccupationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports